import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        wrapper: {
            width: '100%',
            margin: theme.spacing(0.25),
            display: 'flex',
            flexWrap: 'wrap',
            gap: theme.spacing(0.25),
        },
        chip: {
            display: 'inline-block',
            background: theme.palette.secondary[200],
            fontSize: theme.typography.button.fontSize,
            verticalAlign: 'middle',
            borderRadius: 18,
            color: theme.palette.secondary[800],
            padding: theme.spacing(1),
            margin: `${theme.spacing(0.2)} ${theme.spacing(0.2)} 0 0`,
            overflow: 'hidden',
        },
    }
})
